import { render } from "./review-upload-modal-question.vue?vue&type=template&id=90fe5b8a&ts=true"
import script from "./review-upload-modal-question.ts?vue&type=script&lang=ts&external"
export * from "./review-upload-modal-question.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__